export default __webpack_public_path__ + "static/media/youtubeDark.fd67a4f4.svg";